"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.myanmarTranslations = void 0;
var _types = require("../../../types");
const myanmarTranslations = exports.myanmarTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'တောင်းပန်ပါတယ်!',
  [_types.ErrorPageTranslationKey.buttonText]: 'ကျော',
  [_types.ErrorPageTranslationKey.text]: 'ဤစာမျက်နှာသည် လောလောဆယ် တွင်တွင်ကျယ်နေပါသည်။',
  [_types.ErrorPageTranslationKey.notFound]: 'သင်ရှာဖွေနေသော စာမျက်နှာကို မရနိုင်ပါ။',
  [_types.ErrorPageTranslationKey.unauthorized]: 'သင်ရောက်ရှိရန်ကြိုးစားနေသည့် စာမျက်နှာကို ကန့်သတ်ထားပြီး သတ်မှတ်ချက်အားလုံးကို မပြည့်မီပါ။',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'ကျေးဇူးပြု၍ Oriflame ပံ့ပိုးကူညီမှုအဖွဲ့ကို အီးမေးလ်ဖြင့် ဆက်သွယ်ပါ-',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'တောင်းဆိုထားသည့် URL ကို ပယ်ချခဲ့သည်။'
};
